import { IDeadlineSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { getFormattedQuarter } from './formatters';

export const getFormattedDeadlinePeriod = (deadline?: IDeadlineSchema | null): string => {
  if (!deadline || !deadline.year) {
    return '';
  }

  return `${getFormattedQuarter(deadline.quarter)} ${deadline.year}`.trim();
};
